"use client"

import styles from "./styles/ShopWidget.module.scss";
import classNames from "classnames";
import ShopOfferings from "../blocks/TerracedGridTheme/ShopTerrace/ShopOfferings";
import {useGearLaunchShop} from "../../hooks/useGearLaunchShop";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import WatsonApi from "../../backends/WatsonApi";
import {useStores} from "../../stores/useStores";

export function ShopWidget(props) {
    const {organizationStore} = useStores();
    const { data, isLoading, mutate } = useGearLaunchShop();

    useAsyncEffect(async () => {
        if (!isLoading && data?.message === "Error fetching shop data.") {
            const client = await WatsonApi();
            await client.apis.organizations.organizations_create_gearlaunch_shop({
                id: organizationStore.currentOrganization.id,
            });
            await mutate();
        }
    }, [isLoading, organizationStore.currentOrganization.id]);


    const blockHeadClassName = classNames({
        "sb-blockHead": true,
        "sb-organization-color-block-bg": true,
        "sb-block-head-border": true,
        [styles.header]: true,
    })

    return <div className={classNames(styles.widget)}>
        <div className={blockHeadClassName}>
            Spirit Store
            {data?.storeUrl && <a href={data?.storeUrl} className={styles.link}>View All</a>}
        </div>
        <ShopOfferings data={data?.items}
                       isLoading={isLoading}
                       numItemsLoading={3}
                       loadingClassName={styles.loadingClassName}
                       className={styles.shopWidgetContainer}/>
    </div>
}
